import { Component, Input, input, ChangeDetectionStrategy } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { PayoutElement } from '@gbr-monorepo/interfaces';
import { CustomCurrencyPipe } from '../../../../shared/pipes/custom-currency/custom-currency.pipe';

@Component({
    selector: 'app-budget-card',
    templateUrl: './budget-card.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslateModule, CustomCurrencyPipe]
})
export class BudgetCardComponent {
    public readonly title = input<string>();
    public readonly subtitle = input<string>();
    public readonly totalBudget = input<number | null>();

    @Input()
    set payoutElements(value: PayoutElement[]) {
        this._payoutElements = value;
        this.processPayoutElements();
    }

    get payoutElements(): PayoutElement[] {
        return this._payoutElements;
    }

    private _payoutElements: PayoutElement[];
    public employeeSubsidies: PayoutElement[];
    public spouseSubsidies: PayoutElement[];
    public childSubsidies: PayoutElement[];

    private processPayoutElements(): void {
        if (this._payoutElements?.length) {
            this.employeeSubsidies = this._payoutElements.filter(payoutElement => payoutElement.name === 'employeeGid');
            this.spouseSubsidies = this._payoutElements.filter(payoutElement => payoutElement.name === 'spouse');
            this.childSubsidies = this._payoutElements.filter(payoutElement => payoutElement.name === 'child');
        }
    }
}
